import { crossBreedElements } from '@flows/configs/petHealthV2/steps/elements/breeds'
import { v2Text } from '@flows/configs/petHealthV2/steps/elements/shared'
import {
  fetchBreedOptions,
  nextStepAfterBreeds,
  submitBreeds,
} from '@flows/configs/petHealthV2/utils'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const cross_breed_names = (params: StepConfigParams) =>
  ({
    ...fragmentStep(crossBreedElements(params), params, nextStepAfterBreeds('native', params)),
    footer: { defaultButton: { buttonLabel: v2Text('steps.cross_breed.confirm') } },
    onPrepare: fetchBreedOptions(params),
    onSubmit: submitBreeds(params, 'crossbreed', [
      params.helperFunctions.getTransientPath('cross_breeds'),
    ]),
  }) as const satisfies AnyStepConfiguration

export default cross_breed_names
